/* ============================================================
   ARTLEAP — 作品ページの追加ブロック（2026-09-23）
   ・総額（作品代＋梱包料＋送料の目安）の計算
   ・部屋での大きさ（ソファ・ドア・人と実寸比較）の描画

   寸法はここで一度だけ解釈する。実データの表記が幅広いため：
     「50 x 60.6 x 3 cm」「14 x 18 x 2cm」  … cm。3つ目は厚み
     「455×333 mm」「H410×W410×D130mm」   … mm
     「F4号(333×242mm)」「M12号(410×606mm)」… 号数の数字は拾わず「N×N」の組で取る
     「336×598」「970×1303」               … 単位が無いものは mm
   向き（縦か横か）は寸法の記載順ではなく、作品画像の縦横比で決める。
   記載順は作品によってまちまちで、多くは 縦×横 のため。
   ただし画像が正方形（余白を足して正方形に書き出した画像など）だと向きが読めないので、
   そのときは記載順を 縦×横 とみなす（2026-09-27 修正。及川春菜作品など17点が横長に描かれていた）。
   記載順でも合わない作品は、商品タグ orient:縦 / orient:横 で向きを指定する（最優先）。
   ============================================================ */
(function () {
  'use strict';
  /* 画面の文言：layout/theme.liquid → snippets/i18n-js が window.__i18n.pdp に言語ごとの文言を入れる。無ければ日本語の既定（2026-10-25） */
  var I18N = (window.__i18n && window.__i18n.pdp) || {};
  function T(k, d) { var v = I18N[k]; return (v == null || v === '') ? d : v; }

  /* ---------- 寸法の解釈 ---------- */
  var SEP = '[x×X✕╳*]';
  var NUM = '([0-9]+(?:\\.[0-9]+)?)';
  var PAIR = new RegExp(NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM);
  var TRIPLE = new RegExp(NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM + '\\s*' + SEP + '\\s*[A-Za-z]?\\s*' + NUM);

  /* 画像の縦横比がこの幅に収まるときは「正方形」＝向きの手がかりにしない */
  var SQUARE = 0.03;

  function parseDim(raw, ar, orient) {
    if (!raw) return null;
    var s = String(raw);
    var t = TRIPLE.exec(s);
    var m = t || PAIR.exec(s);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    var depth = t ? parseFloat(m[3]) : 0;
    if (!(a > 0) || !(b > 0)) return null;
    /* 単位。cm と書いていなければ mm とみなす */
    if (/mm/i.test(s) || !/cm/i.test(s)) { a /= 10; b /= 10; if (depth) { depth /= 10; } }
    var long = Math.max(a, b), short = Math.min(a, b);
    /* 向きは タグ指定 → 画像 → 記載順（縦×横）の順で決める */
    var land;
    if (orient === 'land' || orient === 'port') { land = orient === 'land'; }
    else if (ar > 0 && Math.abs(ar - 1) >= SQUARE) { land = ar > 1; }
    else { land = b >= a; }
    return {
      long: long, short: short, depth: depth,
      wide: land ? long : short,
      high: land ? short : long
    };
  }

  /* 梱包料（税込・長辺で決まる）と ヤマト宅急便の着払い目安。
     どちらも /policies/shipping-policy の表と同じ。ポリシーを直したらここも直す。
     宅急便は200サイズ（3辺200cm・30kg）まで。180/200 は 2026-09-29 追加
     （ヤマト 2025-10-01 改定の関東発・現金運賃）。 */
  var PACK = [[45, 4400], [90, 7700], [150, 12100]];
  var BOXES = [60, 80, 100, 120, 140, 160, 180, 200];
  var SHIP = {
    kanto:   { 60:  940, 80: 1230, 100: 1530, 120: 2040, 140: 2630, 160: 3020, 180: 3680, 200: 4470 },
    kansai:  { 60: 1060, 80: 1350, 100: 1650, 120: 2170, 140: 2780, 160: 3160, 180: 4480, 200: 5410 },
    chushi:  { 60: 1190, 80: 1480, 100: 1790, 120: 2310, 140: 2930, 160: 3320, 180: 4900, 200: 6220 },
    hokkyu:  { 60: 1460, 80: 1740, 100: 2050, 120: 2610, 140: 3250, 160: 3630, 180: 5220, 200: 6540 },
    okinawa: { 60: 1460, 80: 2070, 100: 2710, 120: 3360, 140: 4030, 160: 4680, 180: 7210, 200: 8860 }
  };

  function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }

  function disclose(btn, body) {
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
    });
  }

  /* ---------- 総額 ---------- */
  (function cost() {
    var box = document.querySelector('[data-cost]');
    if (!box) return;
    disclose(box.querySelector('[data-cost-toggle]'), box.querySelector('.cost__body'));

    var d = parseDim(box.getAttribute('data-dim'), parseFloat(box.getAttribute('data-ar')) || 0);
    var over = box.querySelector('[data-cost-over]');
    var normal = box.querySelector('[data-cost-normal]');
    var packEl = box.querySelector('[data-cost-pack]');
    var noteEl = box.querySelector('[data-cost-packnote]');

    /* 寸法が読めない作品は、梱包・配送とも個別見積として扱う */
    if (!d) {
      if (noteEl) { noteEl.textContent = T('quote_individually', '個別にお見積り'); }
      if (over) { over.hidden = false; }
      return;
    }

    var free = box.getAttribute('data-packfree') === '1';
    var margin = parseFloat(box.getAttribute('data-margin'));
    if (!(margin >= 0)) { margin = 5; }
    var depth = d.depth > 0 ? d.depth : 4;

    var pack = null;
    for (var i = 0; i < PACK.length; i++) {
      if (d.long <= PACK[i][0]) { pack = PACK[i][1]; break; }
    }

    var sum = d.long + d.short + depth + margin;
    var size = 0;
    for (var j = 0; j < BOXES.length; j++) {
      if (sum <= BOXES[j]) { size = BOXES[j]; break; }
    }

    var oversize = pack === null || size === 0;
    /* 重さ等で宅急便に乗らない作品（custom.ship_quote）は寸法に関係なく個別見積（2026-10-10） */
    if (box.getAttribute('data-quote') === '1') { oversize = true; }

    if (free) {
      packEl.textContent = '¥0';
      if (noteEl) { noteEl.textContent = T('free', '無料'); }
    } else if (oversize) {
      packEl.textContent = '—';
      if (noteEl) { noteEl.textContent = T('quote_individually', '個別にお見積り'); }
    } else {
      packEl.textContent = yen(pack);
      if (noteEl) { noteEl.textContent = T('at_order', 'ご注文時'); }
    }

    if (oversize) {
      /* 梱包料が無料の作品では、見積もるのは配送方法だけ */
      if (free) {
        var ot = box.querySelector('[data-cost-overtext]');
        if (ot) { ot.textContent = T('oversize_note', '大作のため、ご注文後に配送方法を個別にご案内します。'); }
      }
      if (over) { over.hidden = false; }
      return;
    }
    if (normal) { normal.hidden = false; }

    var boxEl = box.querySelector('[data-cost-box]');
    if (boxEl) { boxEl.textContent = String(size); }

    var price = parseInt(box.getAttribute('data-price'), 10) || 0;  /* 銭単位 */
    var area = box.querySelector('[data-cost-area]');
    var outS = box.querySelector('[data-cost-ship]');
    var outT = box.querySelector('[data-cost-sum]');
    if (!area || !outS || !outT) return;

    function update() {
      var table = SHIP[area.value];
      var ship = (table && table[size]) || 0;
      outS.textContent = ship ? yen(ship) : '—';
      outT.textContent = yen(Math.round(price / 100) + (free ? 0 : pack) + ship);
    }
    area.addEventListener('change', update);
    update();
  })();

  /* ---------- 部屋での大きさ ---------- */
  (function scale() {
    var box = document.querySelector('[data-scale]');
    if (!box) return;
    var d = parseDim(box.getAttribute('data-dim'), parseFloat(box.getAttribute('data-ar')) || 0, box.getAttribute('data-orient'));
    if (!d) return;                 /* 読めない作品は出さない（hidden のまま） */
    box.hidden = false;

    disclose(box.querySelector('[data-scale-toggle]'), box.querySelector('.scale__body'));

    var svg = box.querySelector('[data-scale-svg]');
    var range = box.querySelector('[data-scale-range]');
    var val = box.querySelector('[data-scale-val]');
    if (!svg) return;

    var artW = d.wide, artH = d.high;
    var round = function (n) { return Math.round(n * 10) / 10; };

    var NS = 'http://www.w3.org/2000/svg';
    function el(name, attrs) {
      var e = document.createElementNS(NS, name);
      for (var k in attrs) { e.setAttribute(k, attrs[k]); }
      return e;
    }
    function label(x, y, text, opts) {
      var t = el('text', {
        x: x, y: y, 'text-anchor': (opts && opts.anchor) || 'middle',
        'font-size': (opts && opts.size) || 10,
        fill: (opts && opts.fill) || '#7d7268',
        'font-family': '-apple-system, BlinkMacSystemFont, "Hiragino Sans", sans-serif',
        'font-weight': (opts && opts.weight) || 400
      });
      t.textContent = text;
      return t;
    }

    function draw(wallCm) {
      var W = 640, H = 380, floorY = 330, pad = 30;
      var px = (W - pad * 2) / wallCm;
      var cx = W / 2;
      function cm(v) { return v * px; }

      while (svg.firstChild) { svg.removeChild(svg.firstChild); }
      svg.appendChild(el('rect', { x: 0, y: 0, width: W, height: H, fill: '#E7E4DF' }));
      svg.appendChild(el('rect', { x: 0, y: floorY, width: W, height: H - floorY, fill: '#CFC7BC' }));
      svg.appendChild(el('line', { x1: 0, y1: floorY, x2: W, y2: floorY, stroke: '#B6ABA0', 'stroke-width': 1 }));

      /* ドア 幅80 × 高さ200 */
      var dw = cm(80), dh = Math.min(cm(200), floorY - 16);
      svg.appendChild(el('rect', { x: W - pad - dw, y: floorY - dh, width: dw, height: dh, fill: '#D8D2C9', stroke: '#B6ABA0', 'stroke-width': 1, rx: 2 }));
      svg.appendChild(el('circle', { cx: W - pad - dw + 10, cy: floorY - dh / 2, r: 2.6, fill: '#9d9287' }));
      svg.appendChild(label(W - pad - dw / 2, floorY - dh - 8, T('door_label', 'ドア 200cm')));

      /* ソファ 幅180 × 背もたれ80 / 座面40 */
      var sw = cm(180), sh = cm(80), seat = cm(40), sx = cx - sw / 2;
      svg.appendChild(el('rect', { x: sx, y: floorY - sh, width: sw, height: sh - seat + cm(8), fill: '#9FA8A0', rx: 4 }));
      svg.appendChild(el('rect', { x: sx, y: floorY - seat, width: sw, height: seat, fill: '#B4BCB3', rx: 4 }));
      svg.appendChild(el('rect', { x: sx, y: floorY - seat - cm(14), width: cm(16), height: seat + cm(14), fill: '#8E978F', rx: 4 }));
      svg.appendChild(el('rect', { x: sx + sw - cm(16), y: floorY - seat - cm(14), width: cm(16), height: seat + cm(14), fill: '#8E978F', rx: 4 }));
      svg.appendChild(label(cx, floorY + 16, T('sofa_label', 'ソファ 幅180cm')));

      /* 人 身長165 */
      var ph = cm(165), pxx = pad + cm(30), hr = cm(11);
      svg.appendChild(el('circle', { cx: pxx, cy: floorY - ph + hr, r: hr, fill: '#8A8F98' }));
      svg.appendChild(el('rect', { x: pxx - cm(16), y: floorY - ph + hr * 2, width: cm(32), height: ph - hr * 2, fill: '#8A8F98', rx: cm(14) }));
      svg.appendChild(label(pxx, floorY + 16, '165cm'));

      /* 作品。床から中心まで145cm */
      var aw = cm(artW), ah = cm(artH);
      var ay = floorY - cm(145) - ah / 2;
      svg.appendChild(el('rect', { x: cx - aw / 2 - 3, y: ay - 3, width: aw + 6, height: ah + 6, fill: '#FFFFFF', stroke: '#C9C2B8', 'stroke-width': 1 }));
      svg.appendChild(el('rect', { x: cx - aw / 2, y: ay, width: aw, height: ah, fill: '#8FA6BE' }));

      /* 寸法線 */
      var accent = '#1A5CD6';
      var ty = ay - 12;
      svg.appendChild(el('line', { x1: cx - aw / 2, y1: ty, x2: cx + aw / 2, y2: ty, stroke: accent, 'stroke-width': 1.2 }));
      svg.appendChild(el('line', { x1: cx - aw / 2, y1: ty - 4, x2: cx - aw / 2, y2: ty + 4, stroke: accent, 'stroke-width': 1.2 }));
      svg.appendChild(el('line', { x1: cx + aw / 2, y1: ty - 4, x2: cx + aw / 2, y2: ty + 4, stroke: accent, 'stroke-width': 1.2 }));
      svg.appendChild(label(cx, ty - 8, round(artW) + 'cm', { size: 11, fill: accent, weight: 600 }));

      var vx = cx + aw / 2 + 14;
      svg.appendChild(el('line', { x1: vx, y1: ay, x2: vx, y2: ay + ah, stroke: accent, 'stroke-width': 1.2 }));
      svg.appendChild(label(vx + 6, ay + ah / 2 + 4, round(artH) + 'cm', { size: 11, fill: accent, weight: 600, anchor: 'start' }));
    }

    function onRange() {
      var v = range ? parseInt(range.value, 10) : 320;
      if (val) { val.textContent = v + ' cm'; }
      draw(v);
    }
    if (range) { range.addEventListener('input', onRange); }
    onRange();
  })();
})();
